
SJ.AirSystem = 
class {
  constructor() {
    this.angle = random(TWO_PI);
    this.newAngle = this.angle;

    // this.airForce = 4;
    this.airForce = random(SJ.V.airMinForce, SJ.V.airMaxForce);

    this.timeX = new Date().getTime();
    this.timeY = new Date().getTime();

    this.windSpeed = {
      max: 0,
      min: 20
    }
  }

  update() {

    this.timeY = new Date().getTime();

    if(this.timeY - this.timeX > SJ.V.airDynamics * 10000){

      this.newAngle = this.getAngleMod();
      this.airForce = this.getNextForce();

      if(this.airForce < this.windSpeed.min) this.windSpeed.min = round(this.airForce * 10) / 10;
      if(this.airForce > this.windSpeed.max) this.windSpeed.max = round(this.airForce * 10) / 10;

      this.timeX = this.timeY;
      this.timeY = new Date().getTime();
    }

    this.angle = lerp(this.angle, this.newAngle, 0.035);
    

    if(SJ.jumper.body.isStatic) {
      return;
    }

    //OLD
    if(SJ.V.mapType !== 'ski'){
      SJ.V.liftForce = 0.00014;
      const forceVector = this.calculateAerodynamicForce();
      const newVelocity = Matter.Vector.add(SJ.jumper.body.velocity, forceVector);
      Matter.Body.setVelocity(SJ.jumper.body, newVelocity);
    } 
    else{

      this.liftForce = this.getLiftForce();
      const newJumperVelocity = Matter.Vector.add(SJ.jumper.body.velocity, this.liftForce);

      Matter.Body.setVelocity(SJ.jumper.body, newJumperVelocity);   

      SJ.jumper.body.frictionAir = this.getAirFriction();
    }

    
    const rotateForce = this.calculateJumperRotateForce();
    const newAngularVelocity = (SJ.jumper.body.angularVelocity + rotateForce) * SJ.V.jumperAngularFriction;
    Matter.Body.setAngularVelocity(SJ.jumper.body, newAngularVelocity);

  }

  getLiftForce(){

    const jumperAngle = SJ.jumper.body.angle;
    
    let x1 = 0;
    let x2 = SJ.jumper.maxBodyAngle;

    if(jumperAngle < 0){
      x2*=-1;
    } 

    let p = (x1 + x2) / 2;
    let a = SJ.V.liftForce / (p - x1) / (p - x2);

    let liftForce = a * (jumperAngle - x1) * (jumperAngle - x2) * -1;

    let windForce = this.airForce * SJ.V.windLiftForce;

    if(this.angle < 1.57 && this.angle > -1.57){
      windForce *= -1;
    }
    else{
      windForce = 0;
    }

    liftForce += windForce;

    liftForce *= SJ.jumperSpeed * 0.012;

    if(jumperAngle > 0)
      liftForce *= 0.5;

    let liftForceVector = SJ.jumper.body.velocity.y > 0 ? Matter.Vector.create(0, liftForce) : Matter.Vector.create(0, liftForce);

    liftForceVector = Matter.Vector.rotate(liftForceVector, SJ.V.liftForceAngle);

    return liftForceVector;
  }

  getAirFriction() {
    const jumperAngle = SJ.jumper.body.angle;
    let windForce = 0;

    // if(this.angle < 1.57 && this.angle > 1.57){
    //   windForce = this.airForce * 0.0005;
    // }
    // else{
    //   windForce = this.airForce * -0.0005;
    // }

    return Math.pow(jumperAngle / 5, 2) * SJ.V.airFriction + windForce;
  }


  getAngleMod() {

    if(random(0, 50) < 1 && SJ.jumper.body.isStatic){
      return this.angle + PI;
    }
    
    const changeDeg = PI / 6;
    const newAngle = random(this.angle - changeDeg, this.angle + changeDeg);

    return newAngle;
  }

  getNextForce() {
    const newForce = this.airForce + random(-0.5, 0.5) * SJ.V.airDynamics;
    return constrain(newForce, SJ.V.airMinForce, SJ.V.airMaxForce);
  }

  calculateAerodynamicForce() {
    const relativeVelocity = this.getRelativeVelocity();
    const relVelSqr = Matter.Vector.magnitudeSquared(relativeVelocity);
    const liftMod = 1;
    
    let force = SJ.V.liftForce * relVelSqr * liftMod * 0.5;

    let forceAngle = this.getVectorAngle(relativeVelocity) - HALF_PI;
    const forceVector = this.getVectorFromAngle(forceAngle, force);

    return forceVector;
  }

  getRelativeVelocity() {
    const airVelocity = this.getAirVelocity();
    return Matter.Vector.sub(SJ.jumper.body.velocity, airVelocity);
  }
  
  getAirVelocity() {
    return this.getVectorFromAngle(this.angle, this.airForce);
  }

  calculateJumperRotateForce() {
    let relativeAngle = this.getRelativeAngle();
    if(abs(relativeAngle) < 0.07) {
      relativeAngle = 0;
    }

    const relativeVelocityMagnitude = Matter.Vector.magnitude(this.getRelativeVelocity())
    let rotateForce = relativeVelocityMagnitude * SJ.V.airRotateForce;
    const MAX_ROTATE_FORCE = 0.1;
    rotateForce = min(rotateForce, MAX_ROTATE_FORCE);
    rotateForce = max(rotateForce, -MAX_ROTATE_FORCE);
    
    const forceMod = SJ.jumper.wantTurn ? 0.5 : 1.0;

    return relativeAngle * rotateForce * forceMod;
  }

  getRelativeAngle() {
    let jumperAngle = SJ.jumper.body.angle;
    
    while(jumperAngle < -PI) {
      jumperAngle += TWO_PI;
    }
    while(jumperAngle > PI) {
      jumperAngle -= TWO_PI;
    }

    if(this.isWindFacingRight()) {
      return jumperAngle - this.angle;
    }else {
      let angle = 0;
      if(this.angle > 0) {
        angle = this.angle - PI;
      }else {
        angle = this.angle + PI;
      }
      return jumperAngle - angle;
    }
  }

  isWindFacingRight() {
    return abs(this.angle) < HALF_PI;
  }

  getVectorAngle(vector) {
    return atan2(vector.y, vector.x);
  }

  getVectorFromAngle(angle, length=1.0) {
    const x = cos(angle) * length;
    const y = sin(angle) * length;
    return Matter.Vector.create(x, y);
  }

}